import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import IconButtonSizes from "./IconButtonComponents/IconButtonSizes";
import IconButtonColors from "./IconButtonComponents/IconButtonColors";
import OutlinedIconButton from "./IconButtonComponents/OutlinedIconButton";
import RoundedIconButton from "./IconButtonComponents/RoundedIconButton";
import RoundedBorderedIconButton from "./IconButtonComponents/RoundedBorderedIconButton";

const IconButtonPage = () => {
  return (
    <>
      <Paper elevation={0}>
        <PageTitleBox
          title={"Icon Button"}
          description={
            "Icon buttons are commonly found in app bars and toolbars.\n" +
            "\n" +
            "Icons are also appropriate for toggle buttons that allow a single choice to be selected or deselected, such as adding or removing a star to an item."
          }
        />
        <Divider light />
        <IconButtonSizes />
        <IconButtonColors />
        <OutlinedIconButton />
        <RoundedIconButton />
        <RoundedBorderedIconButton />
      </Paper>
    </>
  );
};

export default IconButtonPage;
